import { Stack } from '@mui/material';
import DetailItem from 'components/Staff/ItemDetail';
import { formatAmount } from 'utils/helpers';
interface ReceiptModalCardProps {
    invoiceNumber?: number;
    to?: string;
    amount?: string | number;
    note?: string;
}
const ReceiptModalCard = ({ invoiceNumber, to, amount, note }: ReceiptModalCardProps) => {
    return (
        <>
            <Stack p={2} sx={{ backgroundColor: '#dcdcdc' }}>
                <DetailItem fontWeight={400} labelWidth={'100%'} label="To" value={to || ''} />
                <DetailItem fontWeight={400} labelWidth={'100%'} label="Amount" value={formatAmount(amount, 'cents') || '$0'} />
                <DetailItem fontWeight={400} labelWidth={'100%'} label="Note" value={note || '-'} />
                {invoiceNumber && (
                    <>
                        <DetailItem fontWeight={400} labelWidth={'100%'} label={`Invoice # ${invoiceNumber} `} />
                        {/* <DetailItem fontWeight={400} labelWidth={'100%'} label="For your order placed on 6/15/2024" /> */}
                    </>
                )}
                {/* {!invoiceNumber && (
                    <DetailItem
                        fontWeight={400}
                        labelWidth={'100%'}
                        // label={`Payment for service provided on ${dayjs().format('MM/DD/YYYY')}`}
                    />
                )} */}
            </Stack>
        </>
    );
};
export default ReceiptModalCard;
